export default "__VITE_ASSET__BFt0MKOY__"